import { TranslocoPipe, provideTranslocoScope } from '@jsverse/transloco';
import { Component } from '@angular/core';

@Component({
  providers: [provideTranslocoScope('pricelists')],
  selector: 'lis-pricelists-detail',
  imports: [TranslocoPipe, ],
  templateUrl: './pricelists-detail.html',
  styleUrl: './pricelists-detail.scss',
})
export class PricelistsDetail {

}
